<template>
  <div
    class="bb-contact-form-personality"
    :class="[editable && 'bb-contact-form-personality_edit']"
  >
    <label class="bb-form__label bb-contact-form-personality__label">
      Personality
    </label>
    <BBSelectInput
      v-if="editable"
      class="bb-contact-form-personality__select"
      :input="settingsSelect"
      :model="model"
      @input="onChange"
    />
    <div
      v-else
      :class="[`bb-contact-form-personality__icon_${client.clientPersonalityType}`]"
      v-html="HrUserIcon()"
    />
  </div>
</template>

<script>
import BBSelectInput from '@/components/Main/Form/BBSelectInput/BBSelectInput'
import {HrUserIcon} from '@/constants/icon'
import {CLIENT_PERSONALITY_TYPE} from '@/constants/clientPersonalityType'

export default {
  name: 'ContactFormPersonality',
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    client: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    BBSelectInput
  },
  data: () => ({
    HrUserIcon,
    model: {
      clientPersonalityType: undefined
    },
    settingsSelect: {
      model: 'clientPersonalityType',
      listLabel: 'key',
      searchable: false,
      options: CLIENT_PERSONALITY_TYPE
    }
  }),
  methods: {
    onChange ({ id }) {
      this.client.clientPersonalityType = id
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bb-contact-form-personality {
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    height: auto;
    min-height: auto;
    margin: 0 20px;
    padding: 13px 0;
    border-bottom: 1px solid $color-wild-sand;

    &_edit {
      margin: 0 0 18px 0;
      padding: 0 20px 0 25px;
      border-bottom: 0;
    }

    &__label {
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      min-width: 180px;
    }

    &__select {
      width: 100%;
    }
  }
</style>

<style lang="scss">
@import "../../../../../../sass/variables";

  .bb-contact-form-personality__icon {
    &_1 svg path {
      fill: $color-red;
    }

    &_2 svg path {
      fill: $color-yellow;
    }

    &_3 svg path {
      fill: $color-green;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactForm/ContactFormPersonality.vue